import { unwrapResponse } from "../../../../response.js";
import { authHeader, acceptJson } from "../../../../shared.js";
async function signedPrescriptions(apiUrl, accessToken, request) {
  return unwrapResponse(
    await fetch(
      `${apiUrl}/customers/customer/${encodeURIComponent(request.customerId)}/signedprescriptions`,
      {
        method: "GET",
        headers: {
          ...acceptJson,
          ...authHeader(accessToken)
        }
      }
    )
  );
}
export {
  signedPrescriptions
};
//# sourceMappingURL=signedprescriptions.js.map
